import { ServiceCode } from '@common/enums';

export const serviceLabels = {
    [ServiceCode.BariPost]: {
        processTitle: 'Natraject',
        workList: 'Bariatrisch natraject',
    },
    [ServiceCode.BariPre]: {
        processTitle: 'Voortraject',
        workList: 'Bariatrisch voortraject',
    },
    [ServiceCode.DermaC]: {
        patientDossier: 'Algemeen consult',
        procedure: 'Algemeen consult',
        processWizard: 'Algemeen',
        request: 'Aanvraag algemeen consult',
        workList: 'Algemeen consult',
    },
    [ServiceCode.DermaSnelC]: {
        patientDossier: 'Snelconsult algemeen',
        procedure: 'Snelconsult algemeen',
        processWizard: 'Snelconsult algemeen',
        request: 'Aanvraag snelconsult algemeen',
        workList: 'Snelconsult algemeen',
    },
    [ServiceCode.DermaCsc]: {
        patientDossier: 'Dermatoscopie',
        processWizard: 'Dermatoscopie',
        request: 'Aanvraag dermatoscopie',
        workList: 'Consult dermatoscopie',
    },
    [ServiceCode.DermaSnelCsc]: {
        patientDossier: 'Snelconsult dermatoscopie',
        processWizard: 'Snelconsult dermatoscopie',
        request: 'Aanvraag snelconsult dermatoscopie',
        workList: 'Snelconsult dermatoscopie',
    },
    [ServiceCode.DermaCwond]: {
        patientDossier: 'Wond consult',
        procedure: 'Wond consult',
        processWizard: 'Wond',
        request: 'Aanvraag wond consult',
        workList: 'Consult wond',
    },
    [ServiceCode.DermaOth]: {
        patientDossier: 'Thuisconsult',
        procedure: 'Thuisconsult',
        processWizard: 'Thuisconsult',
        request: 'Aanvraag thuisconsult',
        workList: 'Thuisconsult',
    },
    [ServiceCode.Echography]: {
        email: 'Echografie',
        processTitle: 'Echografie',
        workList: 'Echografie',
    },
    [ServiceCode.GGZBmind]: {
        workList: 'Begeleiding',
    },
    [ServiceCode.GGZBther]: {
        workList: 'Begeleiding',
    },
    [ServiceCode.GGZBtherTreat]: {
        workList: 'Begeleiding',
    },
    [ServiceCode.GGZCf2f]: {
        patientDossier: 'Face to face consult',
        procedure: 'Face to face consult',
        processWizard: 'Face to face',
        request: 'Aanvraag face to face consult',
        workList: 'Face to face consult',
    },
    [ServiceCode.GGZCg]: {
        patientDossier: 'Geschreven consult',
        processWizard: 'Geschreven',
        request: 'Aanvraag geschreven consult',
        workList: 'Geschreven consult',
    },
    [ServiceCode.GGZCmdo]: {
        patientDossier: 'MDO consult',
        processWizard: 'MDO',
        request: 'Aanvraag MDO consult',
        workList: 'MDO consult',
    },
    [ServiceCode.GGZCt]: {
        patientDossier: 'Telefonisch consult',
        processWizard: 'Telefonisch',
        request: 'Aanvraag telefonisch consult',
        workList: 'Telefonisch consult',
    },
    [ServiceCode.GGZCtriage]: {
        email: 'Triage consult',
        patientDossier: 'Triage consult',
        procedure: 'Triage consult',
        processWizard: 'Triage',
        request: 'Aanvraag triage consult',
        workList: 'Triage consult',
    },
    [ServiceCode.GGZOembl]: {
        email: 'GGZ onderzoek',
        patientDossier: 'GGZ Embloom onderzoek',
        procedure: 'Embloom onderzoek',
        processWizard: 'GGZ Embloom',
        request: 'Aanvraag Embloom onderzoek',
        workList: 'Embloom onderzoek',
    },
    [ServiceCode.GGZOint]: {
        email: 'GGZ onderzoek',
        patientDossier: 'GGZ Interapy onderzoek',
        procedure: '4DKL+',
        processWizard: 'GGZ Interapy',
        request: '4DKL+ aanvraag',
        workList: '4DKL+',
    },
    [ServiceCode.GGZv]: {
        email: 'GGZ',
        patientDossier: 'Verwijzing',
        request: 'Verwijzing',
        workList: 'Verwijzing',
    },
    [ServiceCode.GTC]: {
        workList: 'Specialistisch consult',
    },
    [ServiceCode.GTO]: {
        request: 'Thuisconsult aanvraag',
        workList: 'Thuisonderzoek',
    },
    [ServiceCode.Headache]: {
        processTitle: 'Hoofdpijn',
        workList: 'Hoofdpijn',
    },
    [ServiceCode.HearingLoss]: {
        email: 'slechthorendheid',
        processTitle: 'Slechthorendheid',
        workList: 'Slechthorendheid',
    },
    [ServiceCode.Holter]: {
        email: 'holter/event',
        processTitle: 'Holter/event',
        workList: 'Holter/event',
    },
    [ServiceCode.LumbarRadiculopathy]: {
        email: 'lage rugpijn met uitstraling',
        processTitle: 'Lage rugpijn met uitstraling',
        workList: 'Lage rugpijn met uitstraling',
    },
    [ServiceCode.OCRK]: {
        costInfoAndConsentModal: 'rijbewijskeuring',
        patientDossier: 'Rijbewijskeuring consult aanvraag',
        processWizard: 'Rijbewijskeuring consult',
        request: 'Consult',
        toast: 'Consult',
        workList: 'Rijbewijskeuring consult',
    },
    [ServiceCode.OORK]: {
        costInfoAndConsentModal: 'rijbewijskeuring',
        email: 'Rijbewijskeuring',
        patientDossier: 'Rijbewijskeuring onderzoek',
        procedure: 'Rijbewijskeuring',
        processWizard: 'Rijbewijskeuring',
        request: 'Rijbewijskeuring',
        toast: 'Onderzoek',
        workList: 'Rijbewijskeuring',
    },
    [ServiceCode.OrthC]: {
        email: 'Orthoptisch consult',
        patientDossier: 'Orthoptisch consult',
        processWizard: 'Orthoptisch consult',
        request: 'Consult',
        workList: 'Orthoptisch consult',
    },
    [ServiceCode.OrthO]: {
        email: 'Eerste Orthoptisch onderzoek',
        patientDossier: 'Eerste Orthoptisch onderzoek',
        procedure: 'Eerste Orthoptisch onderzoek',
        processWizard: 'Eerste Orthoptisch onderzoek',
        request: 'Aanvraag eerste onderzoek Orthoptie',
        workList: 'Eerste Orthoptisch onderzoek',
    },
    [ServiceCode.OrthOFol]: {
        email: 'Vervolg Orthoptisch onderzoek',
        patientDossier: 'Vervolg Orthoptisch onderzoek',
        procedure: 'Vervolg Orthoptisch onderzoek',
        processWizard: 'Vervolg Orthoptisch onderzoek',
        request: 'Aanvraag vervolg onderzoek Orthoptie',
        workList: 'Vervolg Orthoptisch onderzoek',
    },
    [ServiceCode.OSAS]: {
        processTitle: 'OSAS',
        workList: 'Osas',
    },
    [ServiceCode.OSASC1]: {
        patientDossier: 'Eerste poliklinisch consult',
        request: 'Eerste poliklinisch consult',
        workList: 'Eerste consult',
    },
    [ServiceCode.OSASC2]: {
        patientDossier: 'Tweede poliklinisch consult',
        request: 'Tweede poliklinisch consult',
        workList: 'Tweede consult',
    },
    [ServiceCode.OSASE]: {
        processWizard: 'Evaluatie',
        workList: 'Evaluatie behandeling',
    },
    [ServiceCode.OSASEND]: {
        workList: 'Beëindig proefperiode',
    },
    [ServiceCode.OSASN]: {
        email: 'Notitie',
        patientDossier: 'Notitie',
        procedure: 'Notitie',
        workList: 'Notitie',
    },
    [ServiceCode.OSASO]: {
        patientDossier: 'Onderzoek',
        procedure: 'Slaaponderzoek',
        procedureAttachment: '',
        request: 'Aanvraag Slaaponderzoek',
        workList: 'Polygrafie',
    },
    [ServiceCode.OSASQ]: {
        patientDossier: 'ESS & FOSQ10 vragenlijst',
        procedure: 'ESS & FOSQ10 vragenlijst',
        procedureAttachment: 'ESS & FOSQ10 vragenlijst',
        request: 'ESS & FOSQ10 vragenlijst',
        workList: 'ESS & FOSQ10 vragenlijst',
    },
    [ServiceCode.OSASV]: {
        email: 'Verwijzing OSAS',
        patientDossier: 'Verwijzing',
        processWizard: 'Verwijzing',
        request: 'Verwijzing OSAS',
        workList: 'Verwijzing',
    },
    [ServiceCode.OSASVC]: {
        workList: 'Vervolgconsult',
    },
    [ServiceCode.OSASVO]: {
        patientDossier: 'Onderzoek',
        procedure: 'Slaapvervolgonderzoek',
        procedureAttachment: '',
        request: 'Slaapvervolgonderzoek',
        workList: 'Polygrafie',
    },
    [ServiceCode.RespiAller]: {
        workList: 'Luchtwegallergie',
    },
    [ServiceCode.TCCh]: {
        createRequest: 'Consult',
        patientDossier: 'Holter / Event consult',
        processWizard: 'Holter / Event',
        request: 'Consult',
        workList: 'Consult holter / event ECG',
    },
    [ServiceCode.TCCi]: {
        createRequest: 'Consult',
        patientDossier: 'Inspannings ECG consult',
        processWizard: 'Inspannings ECG',
        request: 'Consult',
        workList: 'Consult inspannings ECG',
    },
    [ServiceCode.TCCr]: {
        createRequest: 'Consult',
        patientDossier: 'Rust ECG consult',
        processWizard: 'Rust ECG',
        request: 'Consult',
        workList: 'Consult rust ECG',
    },
    [ServiceCode.TCOH]: {
        createProcedure: 'Holter/Event',
        email: 'holter/event',
        patientDossier: 'Holter / Event onderzoek',
        procedure: 'Holter/Event',
        processWizard: 'Holter / Event',
        request: 'Aanvraag Holter/Event',
        workList: 'Onderzoek holter / event ECG',
    },
    [ServiceCode.TCOR]: {
        createProcedure: 'Rust ECG',
        email: 'rust ECG',
        patientDossier: 'Rust ECG onderzoek',
        procedure: 'Rust ECG',
        processWizard: 'Rust ECG',
        request: 'Aanvraag Rust ECG',
        workList: 'Onderzoek rust ECG',
    },
    [ServiceCode.TFC]: {
        patientDossier: 'Fundusscreening consult',
        processWizard: 'Fundusscreening',
        workList: 'Consult fundusscreening',
    },
    [ServiceCode.TFO]: {
        email: 'Fundusscreening',
        patientDossier: 'Fundusscreening onderzoek',
        procedureAttachment: '',
        processWizard: 'Fundusscreening',
        request: 'Aanvraag fundusscreening',
        workList: 'Onderzoek fundusscreening',
    },
    [ServiceCode.TIECG]: {
        createProcedure: 'Inspannings ECG',
        email: 'inspannings ECG',
        patientDossier: 'Inspannings ECG onderzoek',
        procedure: 'Inspannings ECG',
        processWizard: 'Inspannings ECG',
        request: 'Aanvraag Inspannings ECG',
        workList: 'Onderzoek inspannings ECG',
    },
    [ServiceCode.TOC]: {
        patientDossier: 'Oog algemeen consult',
        processWizard: 'Oog algemeen',
        request: 'Consult',
        workList: 'Consult oogonderzoek',
    },
    [ServiceCode.TOO]: {
        patientDossier: 'Oogonderzoek',
        procedure: 'Oogonderzoek',
        processWizard: 'Oogonderzoek',
        request: 'Aanvraag oogonderzoek',
        workList: 'Algemeen oogonderzoek',
    },
    [ServiceCode.TOV]: {
        workList: 'Verwijzing',
    },
    [ServiceCode.TPC]: {
        createRequest: 'Consultvraag',
        email: 'pulmonologie consultvraag',
        patientDossier: 'Pulmonologie consult',
        request: 'Consult',
        workList: 'Consult',
    },
    [ServiceCode.TPCFlex]: {
        patientDossier: 'Pulmonologie consult',
        workList: 'Consult',
    },
    [ServiceCode.TPO]: {
        createProcedure: 'Longfunctieonderzoek',
        createRequest: 'Vraag longfunctieonderzoek aan',
        email: 'longfunctieonderzoek',
        patientDossier: 'Longfunctieonderzoek',
        procedure: 'Longfunctieonderzoek',
        request: 'Aanvraag Longfunctieonderzoek',
        supervision: 'Supervisie',
        workList: 'Longfunctieonderzoek',
    },
    [ServiceCode.TPOFlex]: {
        patientDossier: 'Longfunctieonderzoek',
        workList: 'Longfunctieonderzoek',
    },
};
